/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */
import React from 'react';
import { Flex, Text } from '@getgo/chameleon-chakra-ui';
import { Button } from './Button';

interface Props {
  link: string;
  handleClick: () => void;
  buttonText: string;
  description: string;
}

export const ButtonOverDescription: React.FC<Props> = (props) => {
  return (
    <Flex
      direction='column'
      alignItems='center'
      justifyContent='center'
      alignSelf='flex-start'
      px='3.25rem'
      py='1.75rem'
    >
      <Button link={props.link} onClick={props.handleClick} my={5}>
        {props.buttonText}
      </Button>
      <Text maxW='15.625rem' textAlign='center' color='#444444'>
        {props.description}
      </Text>
    </Flex>
  );
};
